<template>
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 1.5L5 5.5L1 1.5" stroke-width="1.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>